import React, { useState } from "react";
import closeBtn from "../assets/svg/free-icon-minimize-sign-6057365 2.svg";

const ChangePasswordForm = ({ changePassword }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState("");

  const handleSubmit = (e) => {};

  return (
    <div className="overlay">
      <div className="form-container passwordChange">
        <h2 className="header">СМЕНА ПАРОЛЯ</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Пользователь</label>
            <input
              type="text"
              placeholder="Иванов Иван Иванович"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input"
            />
          </div>

          <div className="form-group">
            <label className="label">Введите текущий пароль</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="input"
            />
          </div>

          <div className="form-group">
            <label className="label">Подтвердите новый пароль</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="input"
            />
          </div>

          <div className="form-group">
            <label className="label">Новый пароль</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="input"
            />
          </div>

          <button type="submit" className="btn popPasswordBtn">
            Подтвердить
          </button>
        </form>
        <div className="closeForm">
          <button className="closePasswordFormBtn" onClick={changePassword}>
            <img src={closeBtn} alt="CloseBtn" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
